export interface BrokerWorkflow {
    id: string;
    regionID: string;
    siteID: string | null;
    mIQ: string | null;
    salesforce: string | null;
    enable_WorkFlow_MIQ: boolean;
    enable_WorkFlow_Salesforce: boolean;
    updatedBy: string | null;   // server-controlled, ignored on create/update input
    updatedAt: string;          // ISO date string, server-controlled
    languageCode: string | null;
    companyID: number | null;
}

export function parseWorkflowFlags(json: string | null): Record<string, boolean> {
    if (!json) { return {}; }
    try {
        return JSON.parse(json) as Record<string, boolean>;
    } catch {
        return {};
    }
}

export function stringifyWorkflowFlags(flags: Record<string, boolean>): string {
    return JSON.stringify(flags);
}